import { routes } from '../../lib/routes';
import { Channel } from '../../model/skill';
import { UserAgreement, UserAgreementDraft } from '../../model/userAgreement';
import { callApi } from '../utils';

export const createUserAgreement = (
    data: Pick<UserAgreementDraft | UserAgreement, 'name' | 'url'>,
    skillId: string,
    channel: Channel,
) =>
    callApi<UserAgreement>({
        data,
        method: 'POST',
        url: routes.app.appStoreApi(`/apps/${skillId}/user-agreements/drafts`),
        queryParams: { channel },
    });

export const updateUserAgreement = (
    data: Pick<UserAgreementDraft | UserAgreement, 'name' | 'url'> & Record<'id', unknown>,
    skillId: string,
    channel: Channel,
) =>
    callApi({
        data,
        method: 'PATCH',
        url: routes.app.appStoreApi(`/apps/${skillId}/user-agreements/drafts/${data.id}`),
        queryParams: { channel },
    });

export const deleteUserAgreement = (data: UserAgreement, skillId: string, channel: Channel) =>
    callApi({
        method: 'DELETE',
        url: routes.app.appStoreApi(`/apps/${skillId}/user-agreements/drafts/${data.id}`),
        queryParams: { channel },
    });

export const getAgreements = (skillId: string, isDraft: boolean, channel: Channel) =>
    callApi<UserAgreement[]>({
        method: 'GET',
        url: routes.app.appStoreApi(`/apps/${skillId}/user-agreements${isDraft ? '/drafts' : ''}`),
        queryParams: { channel },
    });

export const reorderAgreements = (skillId: string, newOrder: Record<string, number>, channel: Channel) =>
    callApi({
        method: 'POST',
        url: routes.app.appStoreApi(`/apps/${skillId}/user-agreements/drafts/reorder`),
        queryParams: { channel },
        data: newOrder,
    });
